<template>
    <PopupRouterView :showLeftIcon="true" label="Stock Opname Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="stockopname"
        :documentId="mainRecordId"
        @saveMethod="finishStockOpname"
        @hideMethod="onHidden"
        ref="stockOpnameInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-combobox-autocomplete :options="stockOpnamePlans" class="big-combobox" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Opname Plan" id="fieldset-stock-opname-plan" size="sm" :model.sync="model.stockOpnamePlanId"   :selected="model.stockOpnamePlan != null ? model.stockOpnamePlan.name : ''" @input="getStockOpnamePlans" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedStockOpnamePlan" :isEditable="!isGantiPic" />
						<app-input-combobox-autocomplete :options="areas" class="big-combobox" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area-sto" size="sm" :model.sync="model.areaStoId"   :selected="model.areaSto != null ? model.areaSto.code : ''" @input="getAreas" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedAreaSto" :isEditable="!isGantiPic"/>
						<app-input-combobox-autocomplete :options="vendors" class="big-combobox" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Subcontract Vendor" id="fieldset-vendor-subcon" size="sm" :model.sync="model.vendorSubconId"   :selected="model.vendorSubcon != null ? model.vendorSubcon.code : ''" @input="getVendors" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedVendorSubcon" v-if="isShowVendorSubcontract" :isEditable="!isGantiPic"/>
						<app-input-scan id="fieldset-id-card" ref="fieldset-id-card" :model.sync="model.idCard" label="ID Card" @scannedMethod="scanIdCard" :isBusy="isBusyScanIdCard" :waitInputScan="waitInputScanIdCard"  @clearMethod="clearMethodScanIdCard"/>
					</b-col>
				</b-row>
			</span>
			<span  v-if="scanPageIndex == 2">
				<app-label label-cols-lg="12" size="sm" label="Area" :model="getAreaLabel()" />
				<app-label label-cols-lg="12" size="sm" label="PIC Scan" :model="this.idCardObj!=null ? this.idCardObj.fullName: ''" />
				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Total Case" :model="this.model!=null ? this.model.totalCaseArea: ''"/>
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Remaining Case" :model="this.model!=null ? this.model.totalCaseArea - this.model.totalCaseActual: ''"  v-on:click.native="showDetailRemaining()"/>
					</b-col>
				</b-row>

				<app-input-scan id="fieldset-case-number" ref="fieldset-case-number" :model.sync="inputCaseNumber" label="Case Number" @scannedMethod="checkCaseNumber" :isBusy="isBusyScanCaseNumber" :waitInputScan="waitInputScanCaseNumber"  @clearMethod="clearMethodScanCaseNumber" />
				<app-label label-cols-lg="12" size="sm" label="Part Number" :model="this.selectedStoDetail!=null && this.selectedStoDetail.part!=null ? this.selectedStoDetail.part.partNumber : ''" />
				<app-label label-cols-lg="12" size="sm" label="Qty System" :model="this.selectedStoDetail!=null && this.selectedStoDetail.controlCard!=null ? this.selectedStoDetail.controlCard.qtyCase : ''" />
				<app-input-textbox id="fieldset-qty-actual" ref="fieldset-qty-actual"  label-cols-lg="12"  label="Qty Actual" label-for="input-qty-actual" size="sm" :model.sync="inputQtyActual" type="number"/>
				<app-input-textbox id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="inputRemarks"/>
				<!-- <app-input-textbox id="fieldset-total-case-actual" label-cols-lg="12" label="Total Case Actual" label-for="input-total-case-actual" size="sm" type="number" :model.sync="model.totalCaseActual"  @change="updateData" /> -->

			</span>
			<span  v-if="scanPageIndex == 3">
				<app-label label-cols-lg="12" size="sm" label="Area" :model="getAreaLabel()" />
				<app-label label-cols-lg="12" size="sm" label="PIC Scan" :model="this.idCardObj!=null ? this.idCardObj.fullName: ''" />
				<div class="table-corner">
					<b-table :stacked="isStacked" id="table-list-remaining-case" :class="'table-action ' + (isStacked ? '' : 'table-index') +'mb-2'" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="remainingCases" :fields="fieldsStockOpnameDetail" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty>
						<template #empty>
							<app-no-data-image />
						</template>
						<template #table-busy v-if="remainingCases.length <= 0">
							<app-no-data-image :animate="true" />
						</template>
						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
						</template>

						<template v-slot:cell(controlCard)="row">
							{{ row.item.controlCard != null ? row.item.controlCard.controlCardNumber : "" }}
						</template>
						<template v-slot:cell(part)="row">
							{{ row.item.part != null ? row.item.part.partNumber : "" }}
						</template>

						<template v-slot:cell(caseQty)="row">
							{{ row.item.controlCard != null ? row.item.controlCard.qtyCase : "" }}
						</template>
						<template v-slot:cell(actions)="row">
							<span>
							<b-button size="sm" class="btn-outline-success float-right" @click="reprint(row.item.controlCard.id)" v-if="row.item.controlCard!=null && row.item.controlCard!=undefined">Reprint</b-button>
							</span>
						</template>
						<template #row-details="row">
							<b-card>
							<app-label label-cols-lg="12" size="sm" label="Customer" :model="(model.partNumber != null) ? (model.partNumber.customer != null) ? model.partNumber.customer.code : null : null"  />
							<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(model.partNumber != null) ? (model.partNumber.partClassification != null) ? model.partNumber.partClassification.code : null : null"  />

							</b-card>
						</template>
					</b-table>
				</div>
				<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(remainingCasesPaging != null ? remainingCasesPaging.dataCount : 0)"
									:per-page="(remainingCasesPaging!= null ? remainingCasesPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="xs" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-sm-2 btn-paging-size normal-size" size="xs">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
				

			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right" @click="nextAction()">Next</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-outline-success float-right" @click="nextCase()">Next Case</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-secondary float-right" @click="gantiPic()">Ganti Pic</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="finishStockOpname()">Finish</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right" @click="scanPageIndex=2">Close</b-button>

        </template>
		<StockOpnameDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelStockOpnameDetail"
			:modelId="stockOpnameDetailId"
			:openPopup="isShowPopupStockOpnameDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataStockOpnameDetail"/>

    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import StockOpname from '@/models/StockOpname/StockOpname';
import StockOpnameList from '@/models/StockOpname/StockOpnameList';
import StockOpnameFilter from '@/filters/StockOpname/StockOpnameFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import VendorType from '@/models/VendorType/VendorType';
import VendorTypeFilter from '@/filters/VendorType/VendorTypeFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import StockOpnameStatus from '@/models/StockOpnameStatus/StockOpnameStatus';
import StockOpnameStatusFilter from '@/filters/StockOpnameStatus/StockOpnameStatusFilter';
import StockOpnameDetail from '@/models/StockOpname/StockOpnameDetail';
import StockOpnameDetailFilter from '@/filters/StockOpname/StockOpnameDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppLabel from '@/components/AppLabel';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import StockOpnameDetailInput from '@/views/StockOpname/StockOpnameDetailInput';
import StockOpnameDetailScan from '@/views/StockOpname/StockOpnameDetailScan';
import StockOpnameDetailUpload from '@/views/StockOpname/StockOpnameDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppLabel,
		AppInputTextarea,
		StockOpnameDetailInput,
		StockOpnameDetailScan,
		StockOpnameDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			// fieldsStockOpnameDetail: [
			// 	{"frontActions": { "class" : "th-actions", "label" : ""}},
			// 	{"no" : { "class" : "th-number d-stack-none"}},
			// 	{"controlCard": { "class" : "th-control-card first-child", "label" : "Case Number", key: 'controlCard.controlCardNumber', sortable: false}},
			// 	{"partLabel": { "class" : "th-part-label", "label" : "Part", key: 'partLabel', sortable: false}},
			// 	{"part": { "class" : "th-part last-child", "label" : "Part", key: 'part.partNumber', sortable: false}},
			// 	{"caseQty": { "class" : "th-case-qty d-stack-none", "label" : "Qty System", key: 'caseQty', sortable: false}},
			// 	{"qtyActual": { "class" : "th-qty-actual d-stack-none", "label" : "Qty Actual", key: 'qtyActual', sortable: false}},
			// 	{"remarks": { "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: false}},
			// 	{"scannedBy": { "class" : "th-scanned-by d-stack-none", "label" : "Scanned By", key: 'scannedBy.firstName', sortable: false}},
			// 	{"userIdCard": { "class" : "th-user-id-card d-stack-none", "label" : "ID Card", key: 'userIdCard', sortable: false}},
			// 	{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			// ],
			fieldsStockOpnameDetail: [
				{"no" : { "class" : "th-number d-stack-none"}},
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card No", key: 'controlCard.controlCardNumber', sortable: false}},
				{"part": { "class" : "th-part last-child", "label" : "Part No", key: 'part.partNumber', sortable: false}},
				{"caseQty": { "class" : "th-case-qty", "label" : "Qty", key: 'caseQty', sortable: false}},
				{"actions": { "class" : "th-actions last-child", "label" : "Action"}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelStockOpnameDetail : {},
			isShowPopupStockOpnameDetail : false,
			isShowPopupUploadStockOpnameDetail : false,
			isShowPopupStockOpnameDetailScan : false,
			filterStockOpname : null,
			currentStockOpnamePage : 1,
			stockOpnamePageSize: 10,
			sortByStockOpname: '',
			sortDescStockOpname: '',
			filterStockOpnameDetail : null,
			currentStockOpnameDetailPage : 1,
			stockOpnameDetailPageSize: 10,
			sortByStockOpnameDetail: '',
			sortDescStockOpnameDetail: '',
			sortingByStockOpnameDetail: [],
			stockOpnameDetails : [],
			stockOpnameDetailId : '',
			totalStockOpnameDetailRow : 0,
			isShowStockOpnameDetailFilter: false,
			isDownloadStockOpnameDetail: false,
			controlCards: [],
			parts: [],
			userInfos: [],
			stockOpnamePlans: [],
			stockOpnamePlans: [],
			isStockOpnamePlanComboLoading: false,
			areas: [],
			areaStos: [],
			isAreaStoComboLoading: false,
			vendors: [],
			vendorSubcons: [],
			isVendorSubconComboLoading: false,
			stockOpnameStatuss: [],
			stockOpnameStatuss: [],
			isStockOpnameStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isStockOpnamePlanComboLoading: false,
			isAreaComboLoading: false,
			isVendorComboLoading: false,
			isStockOpnameStatusComboLoading: false,
			isStockOpnameComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			isUserInfoComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',

			isShowVendorSubcontract : false,
			waitInputScanIdCard : false,
			isBusyScanIdCard : false,
			isGantiPic : false,
			idCardObj : null,
			selectedStoDetail :  null,
			inputCaseNumber : '',
			waitInputScanCaseNumber : false,
			isBusyScanCaseNumber : false,
			inputRemarks : '',
			inputQtyActual : '',
			remainingCases :[],
			remainingCasesPaging : {},	
			isStacked: false,
		}
	},
	methods : {
		async reprint(controlCardId){
			let ids = [];
			ids.push(controlCardId);
			this.isBusy = true;
			let this_ = this;
			try {
				let result = await ControlCard.printControlCard(this_, ids)
				this.isBusy = false;
			} catch {
				this.isBusy = false;
			}
		},
		async showDetailRemaining(){
			this.scanPageIndex=3;
			this.clearInputScanCase();
			await this.getRemainingCases();
		},
		async getRemainingCases(){
			this.isBusy=true;
			let filter = new StockOpnameDetailFilter();

			if (this.modelId == null) return;
			filter.stockOpnameId = this.model.id;
			filter.isScanned = 'false';

			// filter.draftMode = "1";
			// if (this.sortByStockOpnameDetail != null) {
			// 	this.sortingByStockOpnameDetail[this.sortByStockOpnameDetail] = this.sortDescStockOpnameDetail;
			// }
			// let currentPage = (this.currentStockOpnameDetailPage - 1);
			// if (isAddRow) {
			// 	let totalData = this.totalStockOpnameDetailRow + 1;
			// 	let page = Math.ceil(totalData/this.stockOpnameDetailPageSize);
			// 	currentPage = page - 1;
			// }
			// // disable paging start
			// currentPage = null;
			// this.stockOpnameDetailPageSize = 0;
			// disable paging end
			await StockOpnameDetail.getList(this, filter, null,(this.currentPage - 1), this.pageSizeOptions).then(result => {
				// console.log('result.data 2',result.data)
				this.remainingCases = result.data;
				this.remainingCasesPaging = result;
				
				// this.totalRemainingStockOpnameDetail = result.dataCount;
				
				// let totalData = this.totalStockOpnameDetailRow + 1;
				// let page = Math.ceil(totalData/this.stockOpnameDetailPageSize);
				// this.currentPage = page - 1;
				// this.totalStockOpnameDetailRow = this.totalRemainingStockOpnameDetail;
			}).catch(error => {});
			this.isBusy=false;
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		async finishStockOpname(){
			let remainingCasesCount = this.model!=null ? this.model.totalCaseArea - this.model.totalCaseActual: '';
			let areaProcessed = this.getAreaLabel();
			if(remainingCasesCount!='' && remainingCasesCount!= 0 && !await this.showPopupWithMessage("Masih ada "+remainingCasesCount+" case yang belum dilakukan stock opname, apakah anda yakin ingin menyelesaikan proses stock opname pada area "+areaProcessed+" ?")) return;
			let this_ = this;
			this.isBusy = true;
			await this.$http.get('stockopname/finishstockopname?stockOpnameId='+this.model.id)
			.then(function(response){
				this_.isBusy = false; 
				this_.$router.replace('/stockopname/', () => {});
			}).catch(error => { 
				var stringError = 'Gagal finish stock opname';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger',autoHideDelay:3000});
				this_.isBusy = false; 
			});

		},
		
		// rowClass(item, type) {
		// 	if (!item || type !== 'row') return
		// 	if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		// },
		async checkCaseNumber() {
			let qrCode = encodeURIComponent(this.inputCaseNumber);
			let this_ = this;
			this.isBusyScanCaseNumber = true;

			try {
				const response = await this_.$http.get(`stockopname/checkcasenumber/${this.model.id}/?qrCode=${qrCode}`);
				console.log("response checkCaseNumber", response);

				if(response.data == 0) {
					let message = `Control Card ${this.inputCaseNumber} sudah pernah di scan sebelumnya, apa anda yakin ingin melakukan scan untuk control card yang sama?`;
					if(!await this.showPopupWithMessage(message)) {
						this.isBusyScanCaseNumber = false;
						this.inputCaseNumber = '';
						this.clearInputScanCase()
						return;
					} 

					await this.scanCaseNumber();
				}
				else if(response.data == 1) {
					await this.scanCaseNumber();
				}
			}
			catch(error) {
				var stringError = 'Control card yang di scan tidak valid !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				this.isBusyScanCaseNumber = false;
			}
			
			
		},
		async scanCaseNumber(){

			let qrCode = encodeURIComponent(this.inputCaseNumber);
			this.selectedDeliveryCard = null;
			let this_ = this;

			this.isBusyScanCaseNumber = true;

			await this.$http.get('stockopname/scancasenumber?stockOpnameId='+this.model.id+'&caseNumber=' + qrCode)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					this_.selectedStoDetail = response.data;
					if (this_.selectedStoDetail.qtyActual==0 &&(this_.selectedStoDetail.isScanned==''||this_.selectedStoDetail.isScanned==null||this_.selectedStoDetail.isScanned==undefined)) {
						this_.selectedStoDetail.qtyActual = '';
					}
					this_.inputRemarks = this_.selectedStoDetail.remarks;
					this_.inputQtyActual = this_.selectedStoDetail.qtyActual;
					// this_.isBusyScanCaseNumber = false;
					this_.waitInputScanCaseNumber = true;
					
					this_.$nextTick(() => {
						this_.focusInput(this_, "fieldset-qty-actual");
					});

					this_.toast({message: 'Sukses melakukan scan case number !', title:'Info', variant : 'success',autoHideDelay:750});
					return;
				}

				this_.toast({message: 'Tidak valid !', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'Control card yang di scan tidak valid !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
			this.isBusyScanCaseNumber = false;
			this.inputCaseNumber = '';
		},
		async nextCase(){
			this.isBusy = true;
			if (this.selectedStoDetail==null || this.selectedStoDetail==undefined) {
				this.toast({message: "Scan Control Card terlebih dahulu", title:'Error', variant : 'danger'});
				
				this.isBusy = false;
				return;
			}
			if (this.selectedStoDetail!=null) {
				this.selectedStoDetail.remarks = this.inputRemarks;
				this.selectedStoDetail.qtyActual = this.inputQtyActual;
			}
			await StockOpname.nextScanCase(this,this.model.id, this.selectedStoDetail).then(resultUpdate=>{
				this.clearInputScanCase();
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-case-number");
				});
				this.getStockOpname(this.model.id);
				this.isBusy = false;
			})
			.catch((error) => {
				this.isBusy = false;
			});
		},
		clearInputScanCase(){
			this.inputQtyActual='';
			this.inputRemarks='';
			this.selectedStoDetail = null;
			this.waitInputScanCaseNumber=false;
		},
		clearMethodScanCaseNumber(){
			this.selectedStoDetail=null;
			this.inputCaseNumber='';
			this.waitInputScanCaseNumber=false;
			this.$nextTick(() => {
				this.focusInput(this, "fieldset-case-number");
			});
		},
		getAreaLabel(){
			if(this.model==null || this.model==undefined ||this.model.areaSto==null || this.model.areaSto==undefined ){
				return '';
			}
			if (this.model.areaSto.code.toUpperCase()!="VENDOR") {
				return this.model.areaSto.name;
			}
			if (this.model.vendorSubcon==null||this.model.vendorSubcon==undefined||this.model.vendorSubcon=="") {
				return this.model.areaSto.name+"(-)";
			}
			return this.model.areaSto.name+"("+this.model.vendorSubcon.code+")";
		},
		clearMethodScanIdCard(){
			this.model.idCard = '';
			this.waitInputScanIdCard = false;
			
			this.$nextTick(() => {
				this.focusInput(this, "fieldset-id-card");
			});
		},
		getStockOpname : async function(id) {
			this.isBusy = true;
			StockOpname.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();
				if (this.model.areaSto!=null && this.model.areaSto.code.toUpperCase()=="VENDOR") {
					this.isShowVendorSubcontract=true;
				}else{
					this.isShowVendorSubcontract=false;
				}

				// if (this.model.stockOpnameStatus!=null && this.model.stockOpnameStatus.code.toUpperCase()=="IN_PROGRESS") {
				if (this.model.stockOpnameStatus!=null && this.model.stockOpnameStatus.code!=null && this.model.stockOpnameStatus.code!='' && this.model.stockOpnameStatus.code!=undefined) {
					this.isGantiPic=true;
					this.model.idCard='';
				}else{
					this.isGantiPic=false;
				}


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadStockOpname = true;
			this.filterStockOpname.id = this.modelId;
			StockOpname.downloadDataDetail(this, this.filterStockOpname).then(result => {
				this.isDownloadStockOpname = false;
			}).catch(error => { this.isDownloadStockOpname = false; })
		},
		getStockOpnameDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterStockOpnameDetail);
			if (this.modelId == null) return;
			filter.stockOpnameId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByStockOpnameDetail != null) {
				this.sortingByStockOpnameDetail[this.sortByStockOpnameDetail] = this.sortDescStockOpnameDetail;
			}
			let currentPage = (this.currentStockOpnameDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalStockOpnameDetailRow + 1;
				let page = Math.ceil(totalData/this.stockOpnameDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.stockOpnameDetailPageSize = 0;
			// disable paging end
			StockOpnameDetail.getList(this, filter, this.sortingByStockOpnameDetail, currentPage , this.stockOpnameDetailPageSize).then(result => {
				this.currentStockOpnameDetailPage = currentPage + 1;
				this.stockOpnameDetails = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
					);
				this.stockOpnameDetailsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
					);
				this.totalStockOpnameDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getStockOpnames : async function(input) {
			let filter = new StockOpnameFilter();
			if (input != undefined) {
				filter.StockOpnamePlan = input;
			}
			this.isStockOpnameComboLoading = true;
			await StockOpname.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
				}
				this.isStockOpnameComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnames : async function(input) {
			let filter = new StockOpnameFilter();
			if (input != undefined) {
				filter.stockOpnamePlan = input;
			}
			this.isStockOpnameComboLoading = true;
			await StockOpname.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
				}
				this.isStockOpnameComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			await UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnamePlans : async function(input) {
			let filter = new StockOpnamePlanFilter();
			let filterStatus = new StockOpnameStatusFilter();
			filterStatus.code = "IN_PROGRESS";
			let resultStatus = [];
			await StockOpnameStatus.getList(this, filterStatus, null, 0, 10)
			.then(result => {
				if (result != null) {
					resultStatus = result.data
				}
			})
			.catch(error => {});
			if (resultStatus.length<1) {
				this.stockOpnamePlans = [];
				return;
			}

			if (input != undefined) {
				filter.name = input;
			}
			filter.stockOpnameStatusId = resultStatus[0].id;

			await StockOpnamePlan.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpnamePlan(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnamePlanId = null;
				this.model.stockOpnamePlan = null;
			} else {
				this.model.stockOpnamePlanId = item.id;
				this.model.stockOpnamePlan = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if (this.model.stockOpnamePlanId==null ||this.model.stockOpnamePlanId==undefined||this.model.stockOpnamePlanId=='') {
				this.areas = [];
				return;
			}
			filter.stockOpnamePlanId=this.model.stockOpnamePlanId;
			await StockOpname.getListCustomUrl(this,'getlistareaforstockopname', filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedAreaSto(item) {
			if(item == undefined || item == null) {
				this.model.areaStoId = null;
				this.model.areaSto = null;
			} else {
				this.model.areaStoId = item.id;
				this.model.areaSto = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filterVendorType = new VendorTypeFilter();
			filterVendorType.code = 'SUBCONTRACT';
			let resultVendorType = null;
			await VendorType.getList(this, filterVendorType, null, 0, 10)
			.then(result => {
				if (result != null && result.data.length ==1) {
					resultVendorType = result.data[0]
				}
			})
			.catch(error => {});
			if (resultVendorType==null) {
				this.vendors = [];
				return;
			}

			if (this.model.stockOpnamePlanId==null ||this.model.stockOpnamePlanId==undefined||this.model.stockOpnamePlanId=='') {
				this.vendors = [];
				return;
			}
			
			let filter = new VendorFilter();
			filter.vendorTypeId = resultVendorType.id;
			if (input != undefined) {
				filter.code = input;
			}
			filter.stockOpnamePlanId=this.model.stockOpnamePlanId;
			await StockOpname.getListCustomUrl(this,'getlistvendorforstockopname', filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
			// await Vendor.getList(this, filter, null, 0, 10)
			// .then(result => {
			// 	if (result != null) {
			// 		this.vendors = result.data
			// 	}
			// })
			// .catch(error => {});
		},
		setSelectedVendorSubcon(item) {
			if(item == undefined || item == null) {
				this.model.vendorSubconId = null;
				this.model.vendorSubcon = null;
			} else {
				this.model.vendorSubconId = item.id;
				this.model.vendorSubcon = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getStockOpnameStatuss : async function(input) {
			let filter = new StockOpnameStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await StockOpnameStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpnameStatus(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnameStatusId = null;
				this.model.stockOpnameStatus = null;
			} else {
				this.model.stockOpnameStatusId = item.id;
				this.model.stockOpnameStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.stockOpnameInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					StockOpname.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'stockopnameindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					StockOpname.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'stockopnameindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		async nextAction(){
			await this.updateData();
			let id = this.modelId;
			let model = this.model;
			this.isBusy = true;
			let this_ = this;

			await StockOpname.commitData(this, model, id).then(result => {
				StockOpname.getInprogressStockOpname(this,model.id).then(resultInProgress=>{
					if (resultInProgress.id!=model.id) {
						this_.$router.replace('/stockopname/scan/' + resultInProgress.id, () => {
							this_.modelId = resultInProgress.id;
							StockOpname.deleteData(this_,model.id);
							this_.model = resultInProgress;
						});
					}else{
							this_.modelId = resultInProgress.id;
							this_.model = resultInProgress;
					}
				})
				this.scanPageIndex = 2;
				
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-case-number");
				});
				this.waitInputScanIdCard=false;
				this.isBusy = false;
			}).catch(error => {
				this.isBusy = false; 
			});

		},
		gantiPic(){
			this.isGantiPic = true;
			this.model.idCard='';
			this.scanPageIndex = 1;
			this.clearInputScanCase();
			this.$nextTick(() => {
					this.focusInput(this, "fieldset-id-card");
				});
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			if (model.stockOpnamePlanId==null ||model.stockOpnamePlanId==undefined||model.stockOpnamePlanId=='') {
				this.areas = [];
				model.areaStoCode = null;
				model.areaStoId = null;
				model.areaSto = null;
			}

			if (model.areaSto!=null && model.areaSto.code.toUpperCase()=="VENDOR") {
				this.isShowVendorSubcontract=true;
			}else{
				model.vendorSubconId = '';
				model.vendorSubcon = '';
				this.isShowVendorSubcontract=false;
			}


			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return StockOpname.updateData(this, model, id)
					.catch((error) => {
						return this.getStockOpname(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getStockOpnames();
		},
		addRowDataStockOpnameDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.stockOpnameId =  this.modelId;
					StockOpnameDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getStockOpnameDetails(true);
						this.isShowPopupStockOpnameDetail = false;
					})
				} else {
					model.stockOpnameId =  this.modelId;
					StockOpnameDetail.createDataDetail(this, model)
					.then(result => {
						this.getStockOpnameDetails(true);
						this.isShowPopupStockOpnameDetail = false;
					})
				}
			}
		},
		async editRowDataStockOpnameDetail(id) {
			this.stockOpnameDetailId = id;
			this.isShowPopupStockOpnameDetail = true;
		},
		async deleteRowDataStockOpnameDetail(id) {
			StockOpnameDetail.deleteData(this, id).then(result => { this.getStockOpnameDetails(); });
		},
		async resetDataStockOpnameDetail() {
			this.stockOpnameDetailId = "";
			this.isShowPopupStockOpnameDetail = true;
		},
		async addDataStockOpnameDetail() {
			StockOpnameDetail.createData(this, { stockOpnameId: this.modelId })
			.then(result => {
				this.getStockOpnameDetails(true);
			})
		},
		async addFromClipboardStockOpnameDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockOpnameId: this.modelId });
				});
				StockOpnameDetail.addFromClipboard(this, controlCards).then(result => { this.getStockOpnameDetails() });
			});
		},
		async replaceFromClipboardStockOpnameDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockOpnameId: this.modelId });
				});
				StockOpnameDetail.replaceFromClipboard(this, controlCards).then(result => { this.getStockOpnameDetails() });
			});
		},
		showPopupUploadStockOpnameDetail() {
			this.isShowPopupUploadStockOpnameDetail = true;
		},
		uploadDataStockOpnameDetail(modalEvent, newDatas) {
			this.isShowPopupUploadStockOpnameDetail = false;
		},
		downloadStockOpnameDetail(modalEvent) {
			this.isDownloadStockOpnameDetail = true;
			this.filterStockOpnameDetail.stockOpnameId = this.modelId;
			StockOpnameDetail.downloadDataDetail(this, this.filterStockOpnameDetail).then(result => {
				this.isDownloadStockOpnameDetail = false;
			}).catch(error => { this.isDownloadStockOpnameDetail = false; })
		},
		saveInputStockOpnameDetail(item) {
			if (this.stockOpnames != null && this.stockOpnames != undefined  && this.stockOpnames.length > 0) {
				item.stockOpname = this.stockOpnames.find(q => q.id == item.stockOpnameId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.scannedBy = this.userInfos.find(q => q.id == item.scannedByUserName);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockOpnameDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadStockOpnameDetail = false;
			this.isShowPopupStockOpnameDetail = false;
			if (modalType == 'StockOpnameDetail') {
				this.getStockOpnameDetails();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		async scanIdCard() {
			this.isBusyScanIdCard = true;
			let this_ = this;
			let filter = new UserInfoFilter();
			let qrCode = encodeURIComponent(this.model.idCard);
			// console.log('qrCode',qrCode);
			filter.exactType.userName='1';
			filter.userName=qrCode;
			await UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					if (result.data.length==1 && this.model.idCard == result.data[0].userName) {
						this.waitInputScanIdCard=true;
						this_.idCardObj = result.data[0];
						this_.toast({message: 'User Ditemukan !', title:'Info', variant : 'success',autoHideDelay:750});
					}else{
						this_.toast({message: 'User dengan Username ['+this.model.idCard+'] tidak ditemukan', title:'Error', variant : 'danger'});
						this.model.idCard = '';
					}
				}
				// this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
			this.isBusyScanIdCard = false;
		},
		goToNext(page, item) {
			if (page==1) {
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-id-card");
				});
			}else if (page==2) {
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-case-number");
				});
			}
		},
	},
	beforeMount() {
		this.filterStockOpname = new StockOpnameFilter();
		this.filterStockOpnameDetail = new StockOpnameDetailFilter();
		//this.getStockOpnames();
		//this.getControlCards();
		//this.getParts();
		//this.getUserInfos();
		//this.getStockOpnamePlans();
		//this.getAreas();
		//this.getVendors();
		//this.getStockOpnameStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getStockOpname(id);
		}
		this.$nextTick(() => {

			this.$nextTick(() => {
				this.focusInput(this, "fieldset-id-card");
			});
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		currentPage: {
			handler: function() {
				this.getRemainingCases();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getRemainingCases();
			}
		},
		scanPageIndex() {
			this.hideToast();
		},
	},
}
</script>
<style lang="scss" scoped>
.normal-size {
    font-size: 0.875rem !important;
}


::v-deep .big-combobox .vs__dropdown-toggle {
    height: calc(1.5em + .5rem)!important;
    @media (max-width: 576px) {	
        height: calc(1.5em + 2rem)!important;
    }
    padding: 0.25rem 0.5rem;
    font-size: 16px !important;
    line-height: 2.5 !important;
    border-radius: 0rem !important;
    background-color: var(--input-background-color) !important;
    border-color: var(--input-border-color) !important;
    border-width: 0.9px !important;

    .vs__selected {
        white-space: nowrap;
    }

}
::v-deep .big-combobox .vs--open {
    .vs__dropdown-toggle {
        background-color: #F6FBFF !important;
        border-color: #80bdff !important;
        box-shadow: none;
        @media (max-width: 576px) {	
            align-items: center;
            height: calc(1.5em + 2rem) !important;
        }
    }
}
</style>
